export default __webpack_public_path__ + "static/media/hht1_home_img_EP6.14395fb7.png";